const tipos = [
    { label: 'Vertical', value: 'Vertical' },
    { label: 'Horizontal', value: 'Horizontal' },
    { label: 'Comercial', value: 'Comercial' },
];

const status = [
    { label: 'Ativo', value: 'Ativo' },
    { label: 'Futuro', value: 'Futuro' },
    { label: 'Lançado', value: 'Lançado' },
];

const camposTabela = [
    { label: 'Nome do Empreendimento', value: 'name' },
    { label: 'Tipo', value: 'type' },
    { label: 'Construtora', value: 'builder' },
    { label: 'Data Lançamento', value: 'date_sale_start' },
    { label: 'Data Entrega', value: 'date_delivery' },
    { label: 'Cep', value: 'zipcode' },
    { label: 'Endereço', value: 'address' },
    { label: 'Nº Endereço', value: 'number' },
    { label: 'Bairro', value: 'neighborhood' },
    { label: 'Latitude', value: 'latitude' },
    { label: 'Longitude', value: 'longitude' },
    { label: 'Elevadores', value: 'elevator' },
    { label: 'Torres', value: 'towers' },
    { label: 'Andares', value: 'floors' },
    { label: 'Banheiros', value: 'qty_bathrooms' },
    { label: 'Possui suítes', value: 'has_suites' },

    { label: 'Cidade', value: 'city' },
    { label: 'Estado', value: 'state' },

    { label: 'Suítes', value: 'suites' },
    { label: 'Dormitórios', value: 'number_bedroom' },
    { label: 'Vagas Garagem', value: 'garage' },
    { label: 'Tipologia', value: 'type_of_typology' },
    { label: 'Quantidade Lançada', value: 'qty' },
    { label: 'Preço Lançamento', value: 'release_price' },

    { label: 'Status Empreendimento', value: 'status' },
    { label: 'Quantidade Empreendimento', value: 'qty_units' },
    { label: 'Estoque Empreendimento', value: 'stock' },
    { label: 'Total Vendas Empreendimento', value: 'sold' },
    { label: 'Distratos Empreendimento', value: 'distractions' },
    { label: 'Vendas Empreendimento', value: 'sold_in_period' },
    { label: 'Padrão', value: 'pattern' },
    { label: 'Preço Médio Empreendimento', value: 'avg_ticket' },
    { label: 'Preço Área Privativa Empreendimento', value: 'avg_ticket_meter_privative' },
    { label: 'VGV Empreendimento', value: 'vgv' },
    { label: 'Financiamento Próprio', value: 'financiamento_proprio' },
    { label: 'Financiamento Bancário', value: 'financiamento_bancario' },
    { label: 'Valor entrada', value: 'valor_entrada' },
    { label: '% Entrada', value: 'porcentagem_entrada' },
    { label: 'Nº Parcelas', value: 'numero_parcelas' },
    { label: 'Valor Desconto', value: 'valor_desconto' },
    { label: '% Desconto', value: 'percentual_desconto' },
    { label: 'Índice Juros', value: 'indice_juros' },
    { label: 'Taxa Juros', value: 'taxa_juros' },
    { label: 'Taxa Associativa', value: 'taxa_associativa' },

    { label: 'Área Privativa', value: 'private_area' },
    { label: 'Status Tipologia', value: 'status' },
    { label: 'Período', value: 'period' },
    { label: 'Quantidade', value: 'qty' },
    { label: 'Preço', value: 'price' },
    { label: 'Preço Área Privativa', value: 'price_private_area' },
    { label: 'Estoque', value: 'stock' },
    { label: 'Total Vendas', value: 'sold' },
    { label: 'Vendas', value: 'sold_in_period' },
    { label: 'Distratos', value: 'distractions' },
    { label: 'Valor Parcelas', value: 'valor_parcelas' },
];

const PADROES_HORIZONTAIS_SEM_UNIDADES_HABITACIONAIS = [
    'Loteamento Aberto',
    'Loteamento Fechado',
    'Condomínio de Chácaras',
];

// Campos de tipologia que não se aplicam ao tipo/padrão do empreendimento (devem aparecer em branco).
const camposTipologiaOcultos = (tipo, padrao) => {
    if (tipo === 'Comercial') {
        return ['quartos', 'suites'];
    }

    if (tipo === 'Horizontal' && PADROES_HORIZONTAIS_SEM_UNIDADES_HABITACIONAIS.includes(padrao)) {
        return ['quartos', 'suites', 'garagem'];
    }

    return [];
};

export { tipos, status, camposTabela, camposTipologiaOcultos };